import React from "react";
import { toBRDate } from "../../../core/cimInterdicoes.utils";
import InterdicaoListaCardShell, { PanelBlock } from "./InterdicaoListaCardShell";

function toBRDateTime(value, hour) {
  if (!value) return "-";
  return hour ?`${toBRDate(value)} às ${hour}` : toBRDate(value);
}

export default function InterdicaoListaVagoesCard({ item, onOpen }) {
  return (
    <InterdicaoListaCardShell
      item={item}
      onOpen={onOpen}
      layoutClassName="interd-listRowMain interd-listRowMain--vagoes"
    >
      <div className="interd-listCol">
        <div className="interd-panelGrid">
          <PanelBlock label="Início" value={toBRDateTime(item.dataInicio, item.horaInicio)} />
          <PanelBlock
            label="Previsão de término"
            value={item.temPrevisao ?toBRDateTime(item.dataFim, item.horaFim) : "Sem previsão"}
            muted={!item.temPrevisao}
          />
        </div>
      </div>

      <div className="interd-listCol">
        <div className="interd-panelGrid interd-panelGrid--triplet">
          <PanelBlock label="SB" value={item.sb || "-"} />
          <PanelBlock label="SUB" value={item.sub || "-"} />
          <PanelBlock
            label="KM"
            value={item.kmFinal ?`${item.kmInicial || "-"} até ${item.kmFinal}` : item.kmInicial || "-"}
            wide
          />
        </div>
      </div>

      <div className="interd-listCol">
        <div className="interd-panelGrid">
          <PanelBlock label="Trem" value={item.trem || "-"} accent />
          <PanelBlock label="Nº Ativo" value={item.ativo || "-"} />
        </div>
      </div>

      <div className="interd-listCol">
        <div className="interd-panelGrid">
          <PanelBlock label="Motivo" value={item.motivo || "-"} accent />
          <PanelBlock
            label="Observação"
            value={item.observacao || "Sem observação"}
            multiline
            muted={!item.observacao}
          />
        </div>
      </div>
    </InterdicaoListaCardShell>
  );
}
